import { useEffect, useState } from "react";
import { getEvents } from "../../../../api/api";
import WydarzeniaContainer from "../../../../components/elements/WydarzeniaContainer/WydarzeniaContainer";
import MiddleBlock from "../../../../components/MiddleBlock/MiddleBlock";
import EventsButton from "./components/EventsButton";
import "./EventsBlock.css"
import Loader from "../../../../components/elements/Loader/Loader";
import { parseEventColors } from "../../../../utils/parseEventColors";
import EmptyState from "../../../../components/elements/EmptyState/EmptyState";

export default function EventsBlock() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadEvents() {
            try {
                const data = await getEvents(2);
                setEvents(Array.isArray(data?.data) ? data.data : []);
            } catch (error) {
                console.error('Nie udało się wczytać wydarzeń:', error);
                setEvents([]);
            } finally {
                setLoading(false);
            }
        }
        
        loadEvents();
    }, []);



    if (loading) return <Loader />;


    return (
        <MiddleBlock>
            <div className="event-container">
                {events.length > 0 ? events.map(event => {
                    return (
                        <WydarzeniaContainer
                            key={event.id}
                            id={ event.id }
                            title={ event.title }
                            description={ event.short_description }
                            date={ event.event_date }
                            image={ event.image }
                            imagePosition={ event.image_position }
                            imagePositionMobile={ event.image_position_mobile }
                            hex={parseEventColors(event?.colors)}
                        />
                    )
                }) : (
                    <EmptyState type="events" title="Wkrótce pojawią się nowe wydarzenia">
                        Pracujemy nad kolejnymi spotkaniami i projektami. Zajrzyj tu ponownie już niedługo.
                    </EmptyState>
                )}

                {events.length > 0 && <EventsButton />}
            </div>
        </MiddleBlock>
    )
}
